import { disabledControlClasses } from '../common/shared-classes';

export const buttonVariants = {
  default: [
    'bg-secondary',
    'text-secondary-foreground',
    'fill-secondary-foreground',
    'shadow-button',
    'hover:bg-secondary-hover',
    'active:bg-secondary-active',
    'aria-pressed:bg-secondary-active',
    'active:data-[toggled=true]:bg-secondary-active',
    'hover:data-[toggled=true]:bg-secondary-hover',
    'data-[toggled=true]:bg-secondary-active',
  ],
  primary: [
    'bg-primary',
    'text-primary-foreground',
    'fill-primary-foreground',
    'shadow-button',
    'focus-visible:outline-primary/50',
    'hover:bg-primary-hover',
    'active:bg-primary-active',
    'aria-pressed:bg-primary-active',
    'active:data-[toggled=true]:bg-primary-active',
    'hover:data-[toggled=true]:bg-primary-hover',
    'data-[toggled=true]:bg-primary-active',
  ],
  positive: [
    'bg-positive',
    'text-positive-foreground',
    'fill-positive-foreground',
    'shadow-button',
    'focus-visible:outline-positive/50',
    'hover:bg-positive-hover',
    'active:bg-positive-active',
    'aria-pressed:bg-positive-active',
    'active:data-[toggled=true]:bg-positive-active',
    'hover:data-[toggled=true]:bg-positive-hover',
    'data-[toggled=true]:bg-positive-active',
  ],
  negative: [
    'bg-negative',
    'text-negative-foreground',
    'fill-negative-foreground',
    'shadow-button',
    'focus-visible:outline-negative/50',
    'hover:bg-negative-hover',
    'active:bg-negative-active',
    'aria-pressed:bg-negative-active',
    'active:data-[toggled=true]:bg-negative-active',
    'hover:data-[toggled=true]:bg-negative-hover',
    'data-[toggled=true]:bg-negative-active',
  ],
  warning: [
    'bg-warning',
    'text-warning-foreground',
    'fill-warning-foreground',
    'shadow-button',
    'focus-visible:outline-warning/50',
    'hover:bg-warning-hover',
    'active:bg-warning-active',
    'aria-pressed:bg-warning-active',
    'active:data-[toggled=true]:bg-warning-active',
    'hover:data-[toggled=true]:bg-warning-hover',
    'data-[toggled=true]:bg-warning-active',
  ],
  information: [
    'bg-information',
    'text-information-foreground',
    'fill-information-foreground',
    'shadow-button',
    'focus-visible:outline-information/50',
    'hover:bg-information-hover',
    'active:bg-information-active',
    'aria-pressed:bg-information-active',
    'active:data-[toggled=true]:bg-information-active',
    'hover:data-[toggled=true]:bg-information-hover',
    'data-[toggled=true]:bg-information-active',
  ],
  outline: [
    'border',
    'bg-background',
    'text-foreground',
    'fill-foreground',
    'hover:bg-secondary',
    'hover:text-secondary-foreground',
    'hover:fill-secondary-foreground',
    'active:bg-secondary-active',
    'active:text-secondary-foreground',
    'active:fill-secondary-foreground',
    'aria-pressed:bg-secondary-active',
    'aria-pressed:text-secondary-foreground',
    'aria-pressed:fill-secondary-foreground',
    'active:data-[toggled=true]:bg-secondary-active',
    'active:data-[toggled=true]:text-secondary-foreground',
    'active:data-[toggled=true]:fill-secondary-foreground',
    'hover:data-[toggled=true]:bg-secondary-hover',
    'hover:data-[toggled=true]:text-secondary-foreground',
    'hover:data-[toggled=true]:fill-secondary-foreground',
    'data-[toggled=true]:bg-secondary-active',
    'data-[toggled=true]:text-secondary-foreground',
    'data-[toggled=true]:fill-secondary-foreground',
  ],
  transparent: [
    'bg-transparent',
    'text-foreground',
    'fill-foreground',
    'shadow-none',
    'hover:bg-secondary',
    'hover:text-secondary-foreground',
    'hover:fill-secondary-foreground',
    'active:bg-secondary-active',
    'active:text-secondary-foreground',
    'active:fill-secondary-foreground',
    'aria-pressed:bg-secondary-active',
    'aria-pressed:text-secondary-foreground',
    'aria-pressed:fill-secondary-foreground',
    'active:data-[toggled=true]:bg-secondary-active',
    'active:data-[toggled=true]:text-secondary-foreground',
    'active:data-[toggled=true]:fill-secondary-foreground',
    'hover:data-[toggled=true]:bg-secondary-hover',
    'hover:data-[toggled=true]:text-secondary-foreground',
    'hover:data-[toggled=true]:fill-secondary-foreground',
    'data-[toggled=true]:bg-secondary-active',
    'data-[toggled=true]:text-secondary-foreground',
    'data-[toggled=true]:fill-secondary-foreground',
  ],
  link: ['text-primary', 'underline-offset-4', 'hover:underline'],
};

export const setButtonClasses = (el) => {
  el.classList.add(
    'cursor-pointer',
    'inline-flex',
    'items-center',
    'justify-center',
    'gap-2',
    'whitespace-nowrap',
    'rounded-control',
    'text-sm',
    'font-medium',
    'transition-all',
    'duration-100',
    'motion-reduce:transition-none',
    ...disabledControlClasses,
    'svg-defaults',
    'shrink-0',
    'outline-ring/50',
    'focus-outline'
  );
};

export const getButtonSize = (size, isAddon = false) => {
  switch (size) {
    case 'sm':
      return isAddon
        ? ['h-6', '[[data-slot=input-group][data-size=sm]_&]:h-5', 'gap-1', 'px-2', "[&>svg:not([class*='size-'])]:size-3.5", 'has-[>svg]:px-2', 'has-[>[data-slot=spinner]]:px-2']
        : ['h-6.5', 'gap-1.5', 'px-2.5', 'has-[>svg]:px-2', 'has-[>[data-slot=spinner]]:px-2'];
    case 'md':
      return isAddon ? ['h-8', 'px-2.5', 'gap-1.5', 'has-[>svg]:px-2.5', 'has-[>[data-slot=spinner]]:px-2.5'] : ['h-8', 'gap-1.5', 'px-3', 'has-[>svg]:px-2.5', 'has-[>[data-slot=spinner]]:px-2.5'];
    case 'icon-sm':
      return isAddon ? ['size-6', '[[data-slot=input-group][data-size=sm]_&]:size-5', 'p-0', 'has-[>svg]:p-0', 'has-[>[data-slot=spinner]]:p-0'] : ['size-6.5'];
    case 'icon-md':
      return isAddon ? ['size-8', 'p-0', 'has-[>svg]:p-0'] : ['size-8'];
    case 'icon':
      return ['size-9'];
    default:
      return ['h-9', 'px-4', 'py-2', 'has-[>svg]:px-3', 'has-[>[data-slot=spinner]]:px-3'];
  }
};

export default function (Alpine) {
  Alpine.directive('h-button', (el, { original, modifiers }, { cleanup }) => {
    setButtonClasses(el);
    if (!el.hasAttribute('data-slot')) {
      el.setAttribute('data-slot', 'button');
    }

    const isAddon = modifiers.includes('addon');

    let lastSize;

    function setVariant(variant) {
      for (const [_, value] of Object.entries(buttonVariants)) {
        el.classList.remove(...value);
      }
      if (Object.prototype.hasOwnProperty.call(buttonVariants, variant)) el.classList.add(...buttonVariants[variant]);
    }

    function setSize(size = 'default') {
      el.classList.remove(...getButtonSize(lastSize, isAddon));
      el.classList.add(...getButtonSize(size, isAddon));
      if (size.startsWith('icon') && !el.hasAttribute('aria-labelledby') && !el.hasAttribute('aria-label')) {
        console.error(`${original}: Icon-only buttons must have an "aria-label" or "aria-labelledby" attribute`, el);
      }
      lastSize = size;
    }

    setVariant(el.getAttribute('data-variant') ?? 'default');
    if (isAddon) {
      el.classList.remove('shadow-button', 'inline-flex');
      el.classList.add('shadow-none', 'flex');
      setSize(el.getAttribute('data-size') ?? 'sm');
    } else {
      if (el.hasAttribute('data-size')) {
        setSize(el.getAttribute('data-size'));
      } else {
        if (['date-picker-trigger', 'time-picker-trigger'].includes(el.getAttribute('data-slot'))) {
          setSize('icon-sm');
        } else {
          setSize();
        }
      }
    }

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === 'data-variant') setVariant(el.getAttribute('data-variant') ?? 'default');
        else setSize(el.getAttribute('data-size') ?? (isAddon ? 'sm' : 'default'));
      });
    });

    observer.observe(el, { attributes: true, attributeFilter: ['data-variant', 'data-size'] });

    cleanup(() => {
      observer.disconnect();
    });
  });

  Alpine.directive('h-button-group', (el) => {
    el.classList.add(
      'flex',
      'w-fit',
      'items-stretch',
      '[&>*]:focus-visible:z-10',
      '[&>*]:focus-visible:relative',
      "[&>[data-slot=select-trigger]:not([class*='w-'])]:w-fit",
      '[&>input]:flex-1',
      'has-[select[aria-hidden=true]:last-child]:[&>[data-slot=select-trigger]:last-of-type]:rounded-r-control',
      'has-[>[data-slot=button-group]]:gap-2'
    );
    el.setAttribute('role', 'group');
    el.setAttribute('data-slot', 'button-group');
    const variants = {
      horizontal: ['[&>*:not(:first-child)]:rounded-l-none', '[&>*:not(:first-child)]:border-l-0', '[&>*:not(:last-child)]:rounded-r-none'],
      vertical: ['flex-col', '[&>*:not(:first-child)]:rounded-t-none', '[&>*:not(:first-child)]:border-t-0', '[&>*:not(:last-child)]:rounded-b-none'],
    };

    function setVariant(variant) {
      for (const [_, value] of Object.entries(variants)) {
        el.classList.remove(...value);
      }
      if (Object.prototype.hasOwnProperty.call(variants, variant)) el.classList.add(...variants[variant]);
    }

    setVariant(el.getAttribute('data-orientation') ?? 'horizontal');
  });

  Alpine.directive('h-button-group-separator', (el) => {
    el.classList.add('bg-foreground/20', 'shrink-0', '[[data-orientation=vertical]_&]:h-px', '[[data-orientation=vertical]_&]:w-full', 'h-auto', 'w-px', 'relative', 'm-0!', 'self-stretch');
    el.setAttribute('role', 'none');
    el.setAttribute('data-slot', 'button-group-separator');
  });
}
